import "./appTitleBar.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import Icon from "../interface/Icon";
import AppTitleBarTitleView from "./AppTitleBarTitleView";

const AppTitleBarView = props => (
  <div className="appTitleBar">
    {props.menuBar}
    <AppTitleBarTitleView title={props.title} isDirty={props.isDirty} />
    <div className="appTitleBarWindowIcons">
      {props.showMinimize ? (
        <Icon icon="minimizeWindow" onClick={props.onMinimize} tooltip="Minimize Window" canFocus={false} />
      ) : null}
      {props.showMaximize ? (
        <Icon
          icon={props.isMaximized ? "demaximizeWindow" : "maximizeWindow"}
          onClick={() => props.onMaximize(props.isMaximized)}
          tooltip="Maximize Window"
          canFocus={false}
        />
      ) : null}
      {props.showClose ? (
        <Icon
          className="closeWindow"
          icon="closeWindow"
          onClick={props.onClose}
          tooltip="Close Window"
          canFocus={false}
        />
      ) : null}
    </div>
  </div>
);

AppTitleBarView.propTypes = {
  menuBar: PropTypeShapes.elementOrArray.isRequired,
  title: PropTypes.string,
  isDirty: PropTypes.bool,
  isMaximized: PropTypes.bool,
  showMaximize: PropTypes.bool,
  showMinimize: PropTypes.bool,
  showClose: PropTypes.bool,
  onMaximize: PropTypes.func,
  onMinimize: PropTypes.func,
  onClose: PropTypes.func
};

export default AppTitleBarView;
